// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"efb73083","193":"7eeca9d5","213":"21b1fa6f","450":"8b4227af","557":"6bc6fa8a","667":"791b861d"}[chunkId] + ".chunk.js";
};